import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { SalesOrder, UiSoOrder, UiSummarySO, SubSalesOrder, FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, RelayConfigUI, UserType } from '../shared/misc-classes';
import { GenService } from '../shared/gen-ser.service';
import { saleOrderPipe } from '../filters/saleorder.pipe';
import * as XLSX from 'xlsx';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-summary-page',
  templateUrl: './summary-page.component.html',
  styleUrls: ['./summary-page.component.css']
})
export class SummaryPageComponent implements OnInit {
  isSAPLoading: boolean = false;
  soObj: SalesOrder;
  _soObjList: Array<SalesOrder>;

  // @ViewChild('userImpForm') userImpFrm;

  _saleOrderArray: Array<UiSummarySO> = [];
  _selectedCustomer: any;

  _filterPipe: saleOrderPipe = new saleOrderPipe();
  search: string='';
  serialSearch: string='';
  filteredSaleOrderArray: Array<UiSummarySO> = [];
  filteredSOCount:number = 0;
  filteredSSOCount:number = 0;
  filteredQuantity:number = 0;
  filteredPOValue:number = 0;
  filteredCustPOVal:number = 0;
  filteredAmmendPOVal:number =0;
  isDataViewUpdated:boolean = false;
  filteredPOValue_temp:number = 0;
  filteredCustPOVal_temp:number = 0;
  filteredAmmendPOVal_temp:number =0;
  unitName:string='minr'

  isLoading: boolean = false;

  _uiObj: any = [];

  isRevMonthFilterSelected:boolean = false;
  isInvMonthFilterSelected:boolean = false;
  isManfMonthFilterSelected:boolean = false;
  isManfStrategyFilterSelected:boolean = false;
  isOrderTypeFilterSelected: boolean = false;
  isRegionFilterSelected: boolean = false;
  isRelayConfigFilterSelected:boolean = false;
  isUserSelectionFilterSelected:boolean = false;
  userSelectionType:userFilterOption = userFilterOption.All;
  userDeptIdSelected:string[]= [];
  revMonthFilter:monthFilter;
  InvMonthFilter:monthFilter;
  manfMonthFilter:monthFilter;
  manfStrategyIndex:number = 0;
  orderTypeIndex: number= 0;
  regionIndex: number= 0;
  relayConfigIndex: number= 0;
  orderStatusId:string = "0";
  variantTypeId:string = "0";
  quantityTypeId:string = "0"
  mktgDelay:number = 0;
  pmCommDelay:number = 0;
  pmTechDelay:number = 0;
  enggDrawDelay:number = 0;
  scmDelay:number = 0;
  enggProcDelay:number = 0;
  poDelay:number = 0;
  planningDelay:number = 0;
  matRcptDelay:number = 0;
  storesDelay:number = 0;
  productionDelay:number = 0;
  testingDelay:number = 0;
  logisticsDelay:number = 0;
  deliveryDateDelay:number = 0;
  regionSelToken:string = "0,0"; 
  marketingEnggArray:string[]= [];
  projManagerArray:string[]= [];
  projEnggArray:string[]= [];
  elecDesignEnggArray:string[]= [];
  mechDesignEnggArray:string[]= [];
  c30EnggArray:string[]= [];
  userTypeArray:any[]= [];

  private syncedSAPDateSubject = new BehaviorSubject<Date>(null);
  syncedSAPDate$: Observable<Date> = this.syncedSAPDateSubject.asObservable();
  SAPUATAccess: boolean = false;
  Hvr:any = {};
  selectedSAPSo: string = '';
  saleOrderFromSAP: Array<{saleOrdNo: string, status: string, details: string}> = [];
  showSAPModal: boolean = false;
  salesOrderFetchedFromSAP: {date: string, items: Array<{saleOrdNo: string, status: string, details: string}>} = { date: null, items: [] };
  messageDetailsFromSAP: string = '';
  
  constructor(public _dataService: DataService, private _genService: GenService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    try{
      this.loadSettingsFromCookies();
    }catch(e){
      console.log(e);
    }
      this.SAPUATAccess = this._dataService.userType == UserType.MARKETING|| this._dataService.userType == UserType.HOD_MARKETING || this._dataService.userType == UserType.SUPER_ADMIN;

    this.loadData();
    this.getSAPSyncStatus();
    this.cdr.detectChanges();
  }
  saveSettingsToCookies(){
    this._dataService.setCookie('s-search', this.search);
    this._dataService.setCookie('s-search-serial', this.serialSearch);
    this._dataService.setCookie('s-revmonth-sel', this.isRevMonthFilterSelected ? "1":"0");
    if(this.isRevMonthFilterSelected){
      this._dataService.setCookie('s-revmonth-val', this.revMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-invoicingmonth-sel', this.isInvMonthFilterSelected ? "1":"0");
    if(this.isInvMonthFilterSelected){
      this._dataService.setCookie('s-invoicingmonth-val', this.InvMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-manfmonth-sel', this.isManfMonthFilterSelected ? "1":"0");
    if(this.isManfMonthFilterSelected){
      this._dataService.setCookie('s-manfmonth-val', this.manfMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-manfstra-sel', this.isManfStrategyFilterSelected ? "1":"0");
    if(this.isManfStrategyFilterSelected){
      this._dataService.setCookie('s-manfstra-val', this.manfStrategyIndex + '');
    }
    this._dataService.setCookie('s-userdept-sel', this.isUserSelectionFilterSelected ? "1":"0")
    if(this.isUserSelectionFilterSelected){
      this._dataService.setCookie('s-userdept-val', this.userDeptIdSelected + '')
    }
    this._dataService.setCookie('s-ordertype-sel', this.isOrderTypeFilterSelected ? "1":"0");
    if(this.isOrderTypeFilterSelected){
      this._dataService.setCookie('s-ordertype-val', this.orderTypeIndex + '');
    }
    this._dataService.setCookie('s-relayconfig-sel', this.isRelayConfigFilterSelected ? "1":"0");
    if(this.isRelayConfigFilterSelected){
      this._dataService.setCookie('s-relayconfig-val', this.relayConfigIndex + '');
    }
    this._dataService.setCookie('s-region-sel', this.isRegionFilterSelected ? "1":"0");
    if(this.isRegionFilterSelected){
      // this._dataService.setCookie('s-region-val', this.regionIndex + '');
      this._dataService.setCookie('s-region-val', this.regionSelToken);
    }

    this._dataService.setCookie('s-table-opts', 
        `${this.variantTypeId},${this.quantityTypeId},${this.mktgDelay},${this.pmCommDelay},`+
        `${this.pmTechDelay},${this.enggDrawDelay},${this.scmDelay},${this.enggProcDelay},`+
        `${this.poDelay},${this.planningDelay},${this.matRcptDelay},${this.storesDelay},`+
        `${this.productionDelay},${this.testingDelay},${this.logisticsDelay},${this.deliveryDateDelay},${this.orderStatusId}`);
    
  }
  loadSettingsFromCookies(){
    let _tmpSearch:string = this._dataService.getCookie('s-search');
    if(_tmpSearch){
      this.search = _tmpSearch;
    }
    let _tmpSerialSearch:string = this._dataService.getCookie('s-search-serial');
    if(_tmpSerialSearch){
      this.serialSearch = _tmpSerialSearch;
    }
    let _tmpRevMonthSel:string = this._dataService.getCookie('s-revmonth-sel');
    if(_tmpRevMonthSel){
      this.isRevMonthFilterSelected = (_tmpRevMonthSel == "1");

      let _tmpRevMonthVal:string = this._dataService.getCookie('s-revmonth-val');
      if(_tmpRevMonthVal){
        this.revMonthFilter = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
      }
    }
    let _tmpInvMonthSel:string = this._dataService.getCookie('s-invoicingmonth-sel');
    if(_tmpInvMonthSel){
      this.isInvMonthFilterSelected = (_tmpInvMonthSel == "1");

      let _tmpInvMonthVal:string = this._dataService.getCookie('s-invoicingmonth-val');
      if(_tmpInvMonthVal){
        this.InvMonthFilter = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
      }
    }
    let _tmpManfMonthSel:string = this._dataService.getCookie('s-manfmonth-sel');
    if(_tmpManfMonthSel){
      this.isManfMonthFilterSelected = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal:string = this._dataService.getCookie('s-manfmonth-val');
      if(_tmpManfMonthVal){
        this.manfMonthFilter = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }
    let _tmpManfStraSel:string = this._dataService.getCookie('s-manfstra-sel');
    if(_tmpManfStraSel){
      this.isManfStrategyFilterSelected = (_tmpManfStraSel == "1");

      let _tmpManfStraVal:string = this._dataService.getCookie('s-manfstra-val');
      if(_tmpManfStraVal){
        this.manfStrategyIndex = parseInt(_tmpManfStraVal , 10);
      }
    }
    let _tmpUserDeptSel:string = this._dataService.getCookie('s-userdept-sel');
    if(_tmpUserDeptSel){
      this.isUserSelectionFilterSelected = (_tmpUserDeptSel == "1");

      let _tmpUserDeptVal:string = this._dataService.getCookie('s-userdept-val');     
      if(_tmpUserDeptVal){
        this.userDeptIdSelected = _tmpUserDeptVal.split(",");
        this.extractUserDeptSelToken(_tmpUserDeptVal.split(","));
      }
    }
    let _tmpOrderTypeSel:string = this._dataService.getCookie('s-ordertype-sel');
    if(_tmpOrderTypeSel){
      this.isOrderTypeFilterSelected = (_tmpOrderTypeSel == "1");

      let _tmpOrderTypeVal:string = this._dataService.getCookie('s-ordertype-val');
      if(_tmpOrderTypeVal){
        this.orderTypeIndex = parseInt(_tmpOrderTypeVal , 3);
      }
    }
    let _tmpRelayConfigSel:string = this._dataService.getCookie('s-relayconfig-sel');
    if(_tmpRelayConfigSel){
      this.isRelayConfigFilterSelected = (_tmpRelayConfigSel == "1");

      let _tmpRelayConfigVal:string = this._dataService.getCookie('s-relayconfig-val');
      if(_tmpRelayConfigVal){
        this.relayConfigIndex = parseInt(_tmpRelayConfigVal , 10);
      }
    }
    let _tmpRegionSel:string = this._dataService.getCookie('s-region-sel');
    if(_tmpRegionSel){
      this.isRegionFilterSelected = (_tmpRegionSel == "1");

      let _tmpRegionVal:string = this._dataService.getCookie('s-region-val');
      if(_tmpRegionVal){
        // this.regionIndex = parseInt(_tmpRegionVal , 10);
        this.extractRegionSelToken(_tmpRegionVal, true);
      }
    }
    let _tmpTableOptions:string = this._dataService.getCookie('s-table-opts');
    if(_tmpTableOptions){
      let _optTokens:Array<string> = _tmpTableOptions.split(',');
      /*
        `${this.variantTypeId},${this.quantityTypeId},${this.mktgDelay},${this.pmCommDelay},`+
        `${this.pmTechDelay},${this.enggDrawDelay},${this.scmDelay},${this.enggProcDelay},`+
        `${this.poDelay},${this.planningDelay},${this.matRcptDelay},${this.storesDelay},`+
        `${this.productionDelay},${this.testingDelay},${this.logisticsDelay},${this.deliveryDateDelay}`);
      */
     if(_optTokens.length >= 16){
        if(_optTokens[16]){
          this.orderStatusId = _optTokens[16];
        }
        this.variantTypeId = _optTokens[0];
        this.quantityTypeId = _optTokens[1];
        this.mktgDelay = parseInt(_optTokens[2],10);
        this.pmCommDelay = parseInt(_optTokens[3],10);

        this.pmTechDelay = parseInt(_optTokens[4],10);
        this.enggDrawDelay = parseInt(_optTokens[5],10);
        this.scmDelay = parseInt(_optTokens[6],10);
        this.enggProcDelay = parseInt(_optTokens[7],10);

        this.poDelay = parseInt(_optTokens[8],10);
        this.planningDelay = parseInt(_optTokens[9],10);
        this.matRcptDelay = parseInt(_optTokens[10],10);
        this.storesDelay = parseInt(_optTokens[11],10);

        this.productionDelay = parseInt(_optTokens[12],10);
        this.testingDelay = parseInt(_optTokens[13],10);
        this.logisticsDelay = parseInt(_optTokens[14],10);
        this.deliveryDateDelay = parseInt(_optTokens[15],10);
     }
    }

    let _currDate:Date = new Date();
    if(this.revMonthFilter == null){
      this.revMonthFilter = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
      _currDate.getMonth()+1, _currDate.getFullYear());
    }
    if(this.InvMonthFilter == null){
      this.InvMonthFilter = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
      _currDate.getMonth()+1, _currDate.getFullYear());
    }
    if(this.manfMonthFilter == null){
      this.manfMonthFilter = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
      _currDate.getMonth()+1, _currDate.getFullYear());
    }
  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr:Array<SalesOrder>) => {
        this._soObjList = _soObjAr.filter((_tmpSO:SalesOrder) => {
          //test the filter.
          // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
          if(_tmpSO.projectStatus == SOStatus.Dispatched)
          {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }
  // getStatusCSS(_status: FunctionStatus): string {
  //   if (_status == FunctionStatus.WAITING_FOR_PREV) {
  //     return "tab-legend white-legend";
  //   }
  //   if (_status == FunctionStatus.WAITING_FOR_USER_INPUT) {
  //     return "tab-legend grey-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_INCOMPLETE) {
  //     return "tab-legend yellow-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_COMPLETE) {
  //     return "tab-legend green-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
  //     return "tab-legend blue-legend";
  //   }
  //   return "tab-legend white-legend";
  // }
  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }
  // getSSOStatusCSS(_Val): string {
  //   if (_Val == null) return 'hide';
  //   if (_Val > 0) {
  //     return 'clr-green';
  //   }
  //   else if (_Val < 0) {
  //     return 'clr-red';
  //   }
  //   else  
  //     return 'clr-black';
  // }
  getSSOTenDelCSS(_Val): string {
    if (_Val == null) return 'hide';
    if (_Val >= 0) {
      return 'green-legend';
    }
    else {
      return 'red-legend';
    }
    return '';
  }
  expandCollapseRow(_row: any) {
    if (_row.showSSo == false) {
      _row.showSSo = true;
      for (var i = 0; i < this._saleOrderArray.length; i++) {
        if (this._saleOrderArray[i].type == 'sso' && this._saleOrderArray[i].soId == _row.soId) {
          this._saleOrderArray[i].showRow = true;
        }
      }
    }
    else {
      _row.showSSo = false;
      for (var i = 0; i < this._saleOrderArray.length; i++) {
        if (this._saleOrderArray[i].type == 'sso' && this._saleOrderArray[i].soId == _row.soId) {
          this._saleOrderArray[i].showRow = false;
        }
      }
    }
  }

  canCreateSSO(_srow) {
    switch (_srow.projectStatus) {
      case SOStatus.Marketing:
      case SOStatus.PM_Commercial:
      //case SOStatus.PM_Tech:
      case SOStatus.Dispatched:
        return false;

      case SOStatus.Sub_Orders:
        return true;
    }
    return false;

  }
  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void{
    this.search = '';
    this.serialSearch = '';
    this.isRevMonthFilterSelected = false;
    this.isInvMonthFilterSelected = false;
    this.isManfMonthFilterSelected = false;
    this.isManfStrategyFilterSelected = false;
    this.isUserSelectionFilterSelected = false;
    this.isOrderTypeFilterSelected = false;
    this.isRegionFilterSelected = false;
    this.isRelayConfigFilterSelected = false;
    this.orderTypeIndex = 0;
    // this.regionIndex = 0;
    this.relayConfigIndex =0;
    this.manfStrategyIndex = 0;
    this.orderStatusId = "0";
    this.variantTypeId = "0";
    this.quantityTypeId = "0"
    this.mktgDelay = 0;
    this.pmCommDelay = 0;
    this.pmTechDelay = 0;
    this.enggDrawDelay = 0;
    this.scmDelay = 0;
    this.enggProcDelay = 0;
    this.poDelay = 0;
    this.planningDelay = 0;
    this.matRcptDelay = 0;
    this.storesDelay = 0;
    this.productionDelay = 0;
    this.testingDelay = 0;
    this.logisticsDelay = 0;
    this.deliveryDateDelay = 0;
    this.userDeptIdSelected = [];
    this.userTypeArray = [];
    this.marketingEnggArray = [];
    this.projManagerArray = [];
    this.projEnggArray = [];
    this.elecDesignEnggArray = [];
    this.mechDesignEnggArray = [];
    this.c30EnggArray = [];

    this.selectedSAPSo = '';

    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }

  hideThisRow(_row) {
    // if (this._selectedCustomer) {
    //    console.log(_row.custName + ',' + this._selectedCustomer.label)
    // }
    return (this._selectedCustomer && (this._selectedCustomer == '' || _row.custName != this._selectedCustomer));
  }
  extractUserDeptSelToken(_tmpToken){
    let _tmpUserArray = [];
    let _tmpUserArrayUniq = [];
    let _tokens:Array<string> = _tmpToken;
    let _tmpmarketingEnggArray = [];
    let _tmpprojManagerArray = [];
    let _tmpprojEnggArray = [];
    let _tmpelecDesignEnggArray = [];
    let _tmpmechDesignEnggArray = [];
    let _tmpc30EnggArray = [];

    for(let i = 0; i<_tokens.length;i++){
        let _user = _tokens[i].split(':');
        let _userType:userFilterOption = userFilterOption.All;
        _userType =  parseInt(_user[0],10);        
        if(_userType == userFilterOption.MarketingEngineer){
         _tmpUserArray.push(_userType);
         _tmpmarketingEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ProjectManager){
         _tmpUserArray.push(_userType);
         _tmpprojManagerArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ProjectEngineer){
         _tmpUserArray.push(_userType);
         _tmpprojEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ElectricDesignEngineer){
         _tmpUserArray.push(_userType);
         _tmpelecDesignEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.MechanicalDesignEngineer){
         _tmpUserArray.push(_userType);
         _tmpmechDesignEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.C30Engineer){
         _tmpUserArray.push(_userType);
         _tmpc30EnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.All){
          _tmpUserArray = [];
          _tmpUserArray.push(_userType);
        }
    }

    _tmpUserArray.forEach((item) => {  
      if(!_tmpUserArrayUniq.includes(item)){  
         _tmpUserArrayUniq.push(item);  
      }  
   }); 
   
   this.userTypeArray = _tmpUserArrayUniq;
   this.marketingEnggArray = _tmpmarketingEnggArray;
   this.projManagerArray = _tmpprojManagerArray
   this.projEnggArray = _tmpprojEnggArray;
   this.elecDesignEnggArray = _tmpelecDesignEnggArray;
   this.mechDesignEnggArray = _tmpmechDesignEnggArray;
   this.c30EnggArray = _tmpc30EnggArray;
  }

  userSelected(_event){
    this.extractUserDeptSelToken(_event.value);
    this.filterRows();
  }
  extractRegionSelToken(_tmpToken:string, _updateSource:boolean):boolean{    
    let _tokens:Array<string> = _tmpToken.split(',');
     if(_tokens.length == 2 ){
       let regionType = parseInt(_tokens[0], 10); 
       //Comparing with 0 because 0 means 'All' category is are selected
       if(regionType != 0){
         this.regionIndex = parseInt(_tokens[1], 10);         
       }
       else this.regionIndex = 0; // TO SHOW ALL THE VALUES WHEN 'ALL' IS SELECTED
       if(_updateSource == true){
         this.regionSelToken =_tmpToken
       }
       return true;
     }
     return false;
  }
  regionSelected(){
      if(this.extractRegionSelToken(this.regionSelToken, false)){
      this.filterRows();
  }
}
  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();  
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  private _searchKeyTimer:any;
  searchInputChanged(){
    if(this._searchKeyTimer){
      clearTimeout(this._searchKeyTimer);
    }
    this._searchKeyTimer = setTimeout(() => {
      this.filterRows();
    }, (this.search.length < 5 || this.serialSearch.length < 5? 700 : 500));
  }

  private displaySOwithNoSSO(){
    if(this.isRevMonthFilterSelected == true ||this.isInvMonthFilterSelected == true || this.isManfMonthFilterSelected == true || this.isManfStrategyFilterSelected == true || 
      this.isOrderTypeFilterSelected == true || this.isRelayConfigFilterSelected == true || 
      // this.isRegionFilterSelected == true || // COMMENTED BECAUSE THE TOTAL AMMED. PO VAL WAS DIFFEREING WHEN THE FILTER WAS APPLIED 
      this.userTypeArray.includes(userFilterOption.ElectricDesignEngineer) ||
      this.userTypeArray.includes(userFilterOption.MechanicalDesignEngineer) ||
      this.userTypeArray.includes(userFilterOption.C30Engineer) ||
       this.orderStatusId != "0" || this.variantTypeId != "0" || this.quantityTypeId != "0" || this.pmTechDelay != 0 || this.enggDrawDelay != 0 ||
       this.scmDelay != 0 || this.enggProcDelay != 0 || this.poDelay != 0 ||
       this.planningDelay != 0 || this.matRcptDelay != 0 || this.storesDelay != 0 ||
       this.productionDelay != 0 || this.testingDelay != 0 || this.logisticsDelay != 0 ||
       this.deliveryDateDelay != 0 || this.serialSearch !=''
      ){
        return false;
      }

    return true;
  }
  
  filterRowsLogic2(){
    //console.log(1, (new Date()).getTime());
    let _tmpSaleOrderArray: Array<UiSummarySO> = [];
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0; 
    let _tmpCummQuantity: number = 0;
    let _tmpCustPOValue:number = 0;
    let _tmpCustPOVal:number = 0;
    let _tmpAmmendPOVal:number = 0;
    let _tmpUISoObj:UiSummarySO;
    let _showSOWithNoSSO:boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjList.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList[i];  
      
      let _isSOPassedFilter:boolean = this.isSaleOrderTestPassed(_tmpSO);
      if(_isSOPassedFilter == true){
        var _filteredSSO:Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if(_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)){
          //if there are any filtered sso or no actual sso at all(to accomodate new sales orders without suborders)
          //push so to output
          _tmpUISoObj = new UiSummarySO(_tmpSO.salesOrderId, "so", _tmpSO.marketingIP.salesOrderNo,
                                            "", _tmpSO.marketingIP.customerName, "", "", true, false, (_tmpSO.subSalesOrder.length == 0 ? true : false),
                                            _tmpSO.marketingStatus, _tmpSO.pmCommercialStatus, null, null, null, null, null, null, null, null, null, null, 0,
                                            _tmpSO.marketingDays, _tmpSO.marketingDaysTip, null, '', null, '', null, '', null, '', null, '', null, '', null, '',
                                            null, '', null, '', null, '', null, '', "-", null, null, '', "-", _tmpSO.projectStatus, 
                                            _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, null,null);
                                            
          _tmpUISoObj.subOrderCount = _filteredSSO.length;
          _tmpSaleOrderArray.push(_tmpUISoObj);
          var _tmpValue:number = parseFloat(_tmpSO.pmCommercial.poAmmendmentValue);
          if(_tmpValue){
            _tmpAmmendPOVal += _tmpValue;
          }
           var _tmpVal:number = parseFloat(_tmpSO.marketingIP.customerPoValue);
           if(_tmpVal>0 ){
             _tmpCustPOVal += _tmpVal;
           }
          _tmpSOCounter++;
          //push sso array to output
          
          let _tmpUISSoObj:UiSummarySO;

          _filteredSSO.forEach((_tmpSSO:SubSalesOrder) => {

            let _tmpPmTechDays:number = _tmpSSO.pmTechDays;
            let _tmpEnggDrawDays:number = _tmpSSO.enggDrawDays;
            let _tmpSCMDays:number = _tmpSSO.scmCTDays;
            let _tmpEnggProcDays:number = _tmpSSO.enggProcDays;
            let _tmpPurPODays:number = _tmpSSO.purPODays;
            let _tmpPlanDays:number = _tmpSSO.planDays;
            let _tmpMatRcptDays:number = _tmpSSO.purMatRcptDays;
            let _tmpStoreDays:number = _tmpSSO.storeDays;
            let _tmpProductionDays:number = _tmpSSO.productionDays;
            let _tmpTestingDays:number = _tmpSSO.qualityDays;
            let _tmpLogisticsDays:number = _tmpSSO.logisticDays;
            let _tmpDispatchDays:number = _tmpSSO.dispatchDays;
            //let _tmpOrderType: number = _tmpSSO.ordertype;

            _tmpUISSoObj = new UiSummarySO(_tmpSO.salesOrderId, "sso",
                            _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId, _tmpSO.marketingIP.customerName,
                            this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient),
                            _tmpSSO.pmTechSubSalesOrder.panelQuantity + '', true,
                            true, false,
                            0, 0, _tmpSSO.pmTechSubOrderStatus, _tmpSSO.enggDrawStatus, _tmpSSO.scmStatus, _tmpSSO.enggProcureStatus, _tmpSSO.purchasePOStatus, _tmpSSO.planningStatus,
                            _tmpSSO.materialReceiptStatus, _tmpSSO.storeStatus, _tmpSSO.productionStatus, _tmpSSO.qualityStatus, _tmpSSO.logisticsStatus,
                            _tmpSO.marketingDays, '', _tmpPmTechDays, _tmpSSO.pmTechDaysTip, _tmpEnggDrawDays, _tmpSSO.enggDrawDaysTip, _tmpSCMDays, _tmpSSO.scmCTDaysTip,
                            _tmpEnggProcDays, _tmpSSO.enggProcDaysTip, _tmpPurPODays, _tmpSSO.purPODaysTip,
                            _tmpPlanDays, _tmpSSO.planDaysTip, _tmpMatRcptDays, _tmpSSO.purMatRcptDaysTip, _tmpStoreDays, _tmpSSO.storeDaysTip,
                            _tmpProductionDays, _tmpSSO.productionDaysTip, _tmpTestingDays, _tmpSSO.qualityDaysTip,
                            _tmpLogisticsDays, _tmpSSO.logisticDaysTip,
                            GenService.getDateFormatStr(_tmpSSO.pmTechSubSalesOrder.plannedContractualDeliveryDate, "d-mmm-YY"),
                            GenService.getDateFormatStr(_tmpSSO.pmTechSubSalesOrder.reqOrPlndDeliveryDate, "d-mmm-YY"), _tmpDispatchDays, _tmpSSO.dispatchDaysTip,
                            "-", _tmpSO.projectStatus, false, "", _tmpSSO.revenueMonth, _tmpSSO.manufacturingMonth);

              _tmpUISSoObj.projExecStatus = _tmpSSO.pmTechSubSalesOrder.projStatus;
              _tmpSaleOrderArray.push(_tmpUISSoObj);
              if(_tmpSSO.pmTechSubSalesOrder.panelQuantity > 0){
                _tmpCummQuantity += _tmpSSO.pmTechSubSalesOrder.panelQuantity;
              }
              var _contVal:number = _tmpSSO.pmTechSubSalesOrder.contractualValue;
              if(_contVal>0){
                _tmpCustPOValue += _contVal;
              }
              // var _ammendVal:number = _tmpSSO.pm
              _tmpSSOCounter++;
          });
          if(_tmpUISSoObj){
            _tmpUISSoObj.islastSSo = true;
          }
          

        }
      }
    } 

    // if(_tmpUISoSummary){
    //   _tmpUISoSummary.islastSSo = true;
    // }

    this.filteredSaleOrderArray = _tmpSaleOrderArray;
    
    
    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.filteredQuantity = _tmpCummQuantity;
    this.filteredCustPOVal = _tmpCustPOVal;
    this.filteredPOValue = _tmpCustPOValue;
    this.filteredAmmendPOVal = _tmpAmmendPOVal;
    // For the unit convesions
    this.filteredCustPOVal_temp = _tmpCustPOVal;
    this.filteredPOValue_temp = _tmpCustPOValue;
    this.filteredAmmendPOVal_temp = _tmpAmmendPOVal;

    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }
  formatProductName(_fullProductName:string){
    if(_fullProductName.startsWith('UG ') == true){
      return _fullProductName.substring(3);
    }
    else if(_fullProductName.startsWith('LG ') == true){
      return _fullProductName.substring(3);
    }
    return _fullProductName;
  }
  getSaleOrderMessage():string{
    // if(this.isLoading == true) return '';
    // if(this.filteredSOCount == 0 && this.filteredSSOCount == 0) return 'no records.'
    return 'Displaying ' + this.filteredSOCount + ' sale order(s) with ' + this.filteredSSOCount +' sub order(s)';
  }

  getRevMonthLabel():string{
    if(this.isRevMonthFilterSelected == true){
      return "Revenue Month : ";
    }
    else{
      return "Enable Revenue Month Filter";
    }
  }
  getInvMonthLabel():string{
    if(this.isInvMonthFilterSelected == true){
      return "Invoicing Month : ";
    }
    else{
      return "Enable Invoicing Month Filter";
    }
  }
  getManfMonthLabel():string{
    if(this.isManfMonthFilterSelected == true){
      return "Manufacturing Month : ";
    }
    else{
      return "Enable Manufacturing Month Filter";
    }
  }
  getManfStrategyLabel():string{
    if(this.isManfStrategyFilterSelected == true){
      return "Manufacturing Strategy : ";
    }
    else{
      return "Enable Manufacturing Strategy Filter";
    }
  }
  getOrderTypeLabel():string{
    if(this.isOrderTypeFilterSelected == true){
      return "Order Type : "
    }
    else{
      return "Enable Order Type Filter"
    }
  }
  getRelayConfigLabel():string{
    if(this.isRelayConfigFilterSelected == true){
      return "Relay Configuration: "
    }
    else{
      return "Enable Relay Config. Filter"
    }
  }
  getRegionLabel():string{
    if(this.isRegionFilterSelected == true){
      return "Cluster - Region : "
    }
    else{
      return "Enable Cluster- Region Filter"
    }
  }
  getUserFilterLabel():string{
    if(this.isUserSelectionFilterSelected == true){
      return "User Selection : ";
    }
    else{
      return "Enable User Selection Filter";
    }
  }
  getOrderStatusFilterClass(_ordStatusId:string){
    if(_ordStatusId == 'live'){
      return 'clr-green';
    }
    else if(_ordStatusId == 'hold'){
      return  'yellow-back clr-red';
    }
    else if(_ordStatusId == 'cancel'){
      return 'clr-red';
    }
    return '';
  }
  getProductFilterClass(_typeId:string){
    if(_typeId != '0'){
      return 'filter-select red-option';
    }
    return 'filter-select';
  }
  getFilterClass(_opt:number){
    var _cls = '';
    if(_opt == 0){
      _cls = 'grey-option';
    }
    else if(_opt == -1){
      _cls = 'red-option';
    }
    else if(_opt == 1){
      _cls = 'green-option';
    }
    else if(_opt == 2){
      _cls = 'white-legend';
    }
    else if(_opt == 3){
      _cls = 'yellow-legend';
    }
    else if(_opt == 4){
      _cls = 'blue-legend';
    }
    else if(_opt == 5){
      _cls = 'green-legend';
    }
    else if(_opt == 6){
      _cls = 'grey-legend';
    }
    else if(_opt == 7){
      _cls = 'red-legend';
    }

    return _cls +' filter-select';
  }

  getRevFromMonthName():string{
    if(this.revMonthFilter){
      return this.revMonthFilter.fromMonthName;
    }
    return '';
  }
  getRevToMonthName():string{
    if(this.revMonthFilter){
      return this.revMonthFilter.toMonthName;
    }
    return '';
  }
  getInvFromMonthName():string{
    if(this.InvMonthFilter){
      return this.InvMonthFilter.fromMonthName;
    }
    return '';
  }
  getInvToMonthName():string{
    if(this.InvMonthFilter){
      return this.InvMonthFilter.toMonthName;
    }
    return '';
  }
  getManfStrategyName():string{
    if(this.manfStrategyIndex >= 0 && this.manfStrategyIndex < this._dataService.manufacturtingStrategy.length){
      return this._dataService.manufacturtingStrategy[this.manfStrategyIndex].manufacturtingStrategyName;
    }
    return '';
  }
  manfStrategyPrev(){
    if(this.manfStrategyIndex > 0){
      this.manfStrategyIndex--;
    }
    else{
      this.manfStrategyIndex = this._dataService.manufacturtingStrategy.length - 1;
    }
    this.filterRows();
  }
  manfStrategyNext(){
    if(this.manfStrategyIndex < this._dataService.manufacturtingStrategy.length - 1){
      this.manfStrategyIndex++;
    }
    else{
      this.manfStrategyIndex = 0;
    }
    this.filterRows();
  }
  getorderTypeName():string{
    if(this.orderTypeIndex >= 0 && this.orderTypeIndex < this._dataService.ordertypes.length){
      return this._dataService.ordertypes[this.orderTypeIndex].ordertypeName;
    }
    return '';
  }

  orderTypePrev(){
    if(this.orderTypeIndex > 0){
      this.orderTypeIndex--;
    }
    else{
      this.orderTypeIndex = this._dataService.ordertypes.length - 1;
    }
    this.filterRows();
  }
  orderTypeNext(){
    if(this.orderTypeIndex < this._dataService.ordertypes.length - 1){
      this.orderTypeIndex++;
    }
    else{
      this.orderTypeIndex = 0;
    }
    this.filterRows();
  }
  getrelayConfigName():string{
    if(this.relayConfigIndex >= 0 && this.relayConfigIndex < this._dataService.relayconfigs_ui.length){
      return this._dataService.relayconfigs_ui[this.relayConfigIndex].relayconfigName;
    }
    return '';
  }

  relayConfigPrev(){
    if(this.relayConfigIndex > 0){
      this.relayConfigIndex--;
    }
    else{
      this.relayConfigIndex = this._dataService.relayconfigs_ui.length - 1;
    }
    this.filterRows();
  }
  relayConfigNext(){
    if(this.relayConfigIndex < this._dataService.relayconfigs_ui.length - 1){
      this.relayConfigIndex++;
    }
    else{
      this.relayConfigIndex = 0;
    }
    this.filterRows();
  }
  getregionName():string{
    if(this.regionIndex >= 0 && this.regionIndex < this._dataService.regions.length){
      return this._dataService.regions[this.regionIndex].regionName;
    }
    return '';
  }

  regionPrev(){
    if(this.regionIndex > 0){
      this.regionIndex--;
    }
    else{
      this.regionIndex = this._dataService.regions.length - 1;
    }
    this.filterRows();
  }
  regionNext(){
    if(this.regionIndex < this._dataService.regions.length - 1){
      this.regionIndex++;
    }
    else{
      this.regionIndex = 0;
    }
    this.filterRows();
  }
  
  getManfFromMonthName():string{
    if(this.manfMonthFilter){
      return this.manfMonthFilter.fromMonthName;
    }
    return '';
  }
  getManfToMonthName():string{
    if(this.manfMonthFilter){
      return this.manfMonthFilter.toMonthName;
    }
    return '';
  }
  revPrevFromMonth(){
    this.revMonthFilter.prevFromMonth();
    this.filterRows();
  }
  revNextFromMonth(){
    this.revMonthFilter.nextFromMonth();
    this.filterRows();
  }
  revPrevToMonth(){
    this.revMonthFilter.prevToMonth();
    this.filterRows();
  }
  revNextToMonth(){
    this.revMonthFilter.nextToMonth();
    this.filterRows();
  }

  InvPrevFromMonth(){
    this.InvMonthFilter.prevFromMonth();
    this.filterRows();
  }
  InvNextFromMonth(){
    this.InvMonthFilter.nextFromMonth();
    this.filterRows();
  }
  InvPrevToMonth(){
    this.InvMonthFilter.prevToMonth();
    this.filterRows();
  }
  InvNextToMonth(){
    this.InvMonthFilter.nextToMonth();
    this.filterRows();
  }


  manfPrevFromMonth(){
    this.manfMonthFilter.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth(){
    this.manfMonthFilter.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth(){
    this.manfMonthFilter.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth(){
    this.manfMonthFilter.nextToMonth();
    this.filterRows();
  }

  private isSaleOrderTestPassed(_so:SalesOrder):boolean{

    //check sono and customer name in search
    if(this.isSONoCustSearchPassed(_so.marketingIP.salesOrderNo, _so.marketingIP.customerName, 
      _so.pmCommercial.isSaleOrderChangeApplicable, _so.pmCommercial.salesOrderNoNew, this.search) == false) return false;
    
    //check if so user is seleceted
    if(this.isSOUserFilterPassed(_so.marketingIP.marketingEngineerId, _so.marketingIP.projectManagerId, _so.pmCommercial.projectEngineerId) == false) return false;

    //orderType filter
    if(this.isOrderTypeFilterPassed(_so.marketingIP.ordertypeId) == false) return false;

    //Cluster filter
    if(this.isRegionFilterPassed(_so.marketingIP.regionId) == false) return false;

    //check for failure cases
    if(this.isDeptFilterPassed(this.mktgDelay, _so.marketingDays, _so.marketingStatus) == false) return false;

    
    

    if(this.pmCommDelay != 7){
      if(this.isDeptFilterPassed(this.pmCommDelay, 0, _so.pmCommercialStatus) == false) return false;
    }
    else{
      if(_so.projectStatus < SOStatus.Sub_Orders || _so.subSalesOrder.length > 0) return false;
    }

    return true;
  }
  private getFilteredSubOrders(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
    return _ssoAr.filter((_sso:SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;


      //check if sso user is seleceted
      if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId, _sso.enggDrawIP.mechanicalDesignEngineerId, _sso.enggDrawIP.c30EngineerId) == false) return false;
      
      //if a variant type selectde and it is not matching
      if(this.variantTypeId != "0"){
        if(this.variantTypeId != _sso.pmTechSubSalesOrder.productVarient)  return false;
        //Relay Config FIlter
    
      }

      //if a order status is selected and it is not matching
      if(this.orderStatusId != "0"){
        if(this.orderStatusId != _sso.pmTechSubSalesOrder.projStatus) return false;
      }

      //check if quantity type is selected then it matches
      if(this.quantityTypeId != "0"){        
        if(this.isQuantityTypeMatching(_sso.pmTechSubSalesOrder.panelQuantity) == false) return false;
      }

      //check if revenue month 
      if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
      if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
      if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      if(this.isManfStrategyFilterPassed(_sso.manufacturingStrategy) == false) return false;
      if(this.isRelayConfigFilterPassed(_sso.relayconfig) ==false) return false;
      
      if(this.isDeptFilterPassed(this.pmTechDelay, _sso.pmTechDays, _sso.pmTechSubOrderStatus) == false) return false;
      if(this.isDeptFilterPassed(this.enggDrawDelay, _sso.enggDrawDays, _sso.enggDrawStatus) == false) return false;
      if(this.isDeptFilterPassed(this.scmDelay, _sso.scmCTDays, _sso.scmStatus) == false) return false;
      if(this.isDeptFilterPassed(this.enggProcDelay, _sso.enggProcDays, _sso.enggProcureStatus) == false) return false;
      if(this.isDeptFilterPassed(this.poDelay, _sso.purPODays, _sso.purchasePOStatus) == false) return false;
      if(this.isDeptFilterPassed(this.planningDelay, _sso.planDays, _sso.planningStatus) == false) return false;
      if(this.isDeptFilterPassed(this.matRcptDelay, _sso.purMatRcptDays, _sso.materialReceiptStatus) == false) return false;
      if(this.isDeptFilterPassed(this.storesDelay, _sso.storeDays, _sso.storeStatus) == false) return false;
      if(this.isDeptFilterPassed(this.productionDelay, _sso.productionDays, _sso.productionStatus) == false) return false;
      if(this.isDeptFilterPassed(this.testingDelay, _sso.qualityDays, _sso.qualityStatus) == false) return false;
      if(this.isDeptFilterPassed(this.logisticsDelay, _sso.logisticDays, _sso.logisticsStatus) == false) return false;
      if(this.isDeptFilterPassed(this.deliveryDateDelay, _sso.dispatchDays, FunctionStatus.SUBMITTED_COMPLETE) == false) return false;

      //check serial no in search
      if(this.isSSOSerialNoSearchPassed(_sso.serialNos, this.serialSearch) == false) return false;

      return true;
    });
  }
  private isDeptFilterPassed(_selFilter:number, _taskDays:number, _taskStatus:FunctionStatus){
    _selFilter = parseInt(_selFilter + '', 10);
    if(_selFilter != filterOption.All){
      //check for failure cases
      switch(_selFilter){
        case filterOption.Delay:
          if(_taskDays == null || _taskDays >= 0) return false;
        break;
        case filterOption.Early:
          if(_taskDays == null || _taskDays < 0) return false;
        break;
        case filterOption.NotStarted:
          if(_taskStatus != FunctionStatus.WAITING_FOR_PREV) return false;
        break;
        case filterOption.Pending:
          if(_taskStatus != FunctionStatus.WAITING_FOR_USER_INPUT) return false;
        break;
        case filterOption.Partial:
          if(_taskStatus != FunctionStatus.SUBMITTED_INCOMPLETE) return false;
        break;
        case filterOption.Waiting:
          if(_taskStatus != FunctionStatus.SUBMITTED_WAITING_RESPONSE) return false;
        break;
        case filterOption.Complete:
          if(_taskStatus != FunctionStatus.SUBMITTED_COMPLETE) return false;
        break;
        case filterOption.Relay_pending:
          if(_taskStatus != FunctionStatus.RELAY_PENDING) return false;
      }

      // if(//check for failure cases
      //     (_selFilter == filterOption.Delay && _taskDays >= 0) ||
      //     (_selFilter ==  filterOption.Early && _taskDays < 0) ||
      //     (_selFilter ==  filterOption.NotStarted && _taskStatus != FunctionStatus.WAITING_FOR_PREV) ||
      //     (_selFilter ==  filterOption.Pending && _taskStatus != FunctionStatus.WAITING_FOR_USER_INPUT) ||
      //     (_selFilter ==  filterOption.Partial && _taskStatus != FunctionStatus.SUBMITTED_INCOMPLETE) ||
      //     (_selFilter ==  filterOption.Waiting && _taskStatus != FunctionStatus.SUBMITTED_WAITING_RESPONSE) ||
      //     (_selFilter ==  filterOption.Complete && _taskStatus != FunctionStatus.SUBMITTED_COMPLETE)
      //     ){
      //     return false;
      // }
    }
    return true;
  }
  private isQuantityTypeMatching(_panelQty:number):boolean{
      switch (this.quantityTypeId) {
        case "1"://0-10
          if (_panelQty >= 0 && _panelQty <= 10) return true;
          break;
        case "2"://11-20
          if (_panelQty >= 11 && _panelQty <= 20) return true;
          break;
        case "3"://21-50
          if (_panelQty >= 21 && _panelQty <= 50) return true;
          break;
        case "4"://51-100
          if (_panelQty >= 51 && _panelQty <= 100) return true;
          break;
        case "5"://100+
          if (_panelQty > 100) return true;
          break;
      }
      return false;
  }

  private isSONoCustSearchPassed(_soNo:string, _custName:string, 
                                 _isSoNoUpdated:boolean, _newSoNumber:string, 
                                 _srchText:string):boolean{

    if(_srchText != ''){
			_srchText = _srchText.toLowerCase();
			if (_soNo && (_soNo + '').toLowerCase().indexOf(_srchText) >= 0) {
				return true;
      }
      if (_isSoNoUpdated == true && _newSoNumber && (_newSoNumber + '').toLowerCase().indexOf(_srchText) >= 0) {
				return true;
			}
			if (_custName && _custName.toLowerCase().indexOf(_srchText) >= 0){
				return true;
      }
      return false;
    }
    
    return true;
  }
  private isSSOSerialNoSearchPassed(_serialNo: Array<string>,
    _srchText: string): boolean {
      
    if (_srchText != '') {
      _srchText = _srchText.toLowerCase();
      const indexSerial = _serialNo.findIndex(element => {
        if (element.includes(_srchText)) {
          return true;
        }
      });
      if (indexSerial !== -1){
        return true;
      }
      return false;
    }

    return true;
  }
  

  private isRevMonthFilterPassed(_revenueMonth:Date){
    if(this.isRevMonthFilterSelected == true && this.revMonthFilter != null){
        if(this.revMonthFilter.isWithInFilterScope(_revenueMonth) == false) {
          return false;
        }
    }
    return true;
  }
  private isInvMonthFilterPassed(_invoicingmonth:Date){
    if(this.isInvMonthFilterSelected == true && this.InvMonthFilter != null){
        if(this.InvMonthFilter.isWithInFilterScope(_invoicingmonth) == false) {
          return false;
        }
    }
    return true;
  }
  private isManfMonthFilterPassed(_manfMonth:Date){
    if(this.isManfMonthFilterSelected == true && this.manfMonthFilter != null){
        if(this.manfMonthFilter.isWithInFilterScope(_manfMonth) == false) {
          return false;
        }
    }
    return true;
  }
  private isManfStrategyFilterPassed(_manfStraId:string){
    if(this.isManfStrategyFilterSelected == true && 
       this.manfStrategyIndex >= 0 && this._dataService.manufacturtingStrategy[this.manfStrategyIndex]){

        if(this._dataService.manufacturtingStrategy[this.manfStrategyIndex].manufacturtingStrategyId != _manfStraId) {
          return false;
        }

    }
    return true;
  }
  private isOrderTypeFilterPassed(_ordertypeId: string){
    if(this.isOrderTypeFilterSelected == true && this.orderTypeIndex >= 0 && this._dataService.ordertypes[this.orderTypeIndex]){
      if(this._dataService.ordertypes[this.orderTypeIndex].ordertypeId != _ordertypeId){
        return false
      }
    }
    return true;
  }
  private isRelayConfigFilterPassed(_relayconfigId: string){
    if(this.isRelayConfigFilterSelected == true && this.relayConfigIndex >= 0 && this._dataService.relayconfigs_ui[this.relayConfigIndex]){
      if(this._dataService.relayconfigs_ui[this.relayConfigIndex].relayconfigId != _relayconfigId){
        return false
      }
    }
    return true;
  }
  private isRegionFilterPassed(_regionId: string){
    //this.regionIndex-1 is because the array index needs to match with the _regionId
    if(this.isRegionFilterSelected == true && (this.regionIndex-1) >= 0 && this._dataService.regions[this.regionIndex-1]){
      if(this._dataService.regions[this.regionIndex-1].regionId != _regionId){
        return false
      }
    }
    return true;
  }

  private isSOUserFilterPassed(_mktgEngId:string, _projManagerId:string, _projEngId:string):boolean{
    //check for failure cases
    if(this.isUserSelectionFilterSelected == true && !this.userTypeArray.includes(userFilterOption.All)){
      if(this.userTypeArray.includes(userFilterOption.MarketingEngineer)){
        if(!this.marketingEnggArray.includes(_mktgEngId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.ProjectManager)){
        if(!this.projManagerArray.includes(_projManagerId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.ProjectEngineer)){
        if(!this.projEnggArray.includes(_projEngId)) return false;
      }
    }
    return true;
  }
  private isSSOUserFilterPassed(_elecEngId:string, _mechEnggId:string, _c30EngId:string):boolean{
    //check for failure cases
    if(this.isUserSelectionFilterSelected == true && !this.userTypeArray.includes(userFilterOption.All)){
      if(this.userTypeArray.includes(userFilterOption.ElectricDesignEngineer)){
        if(!this.elecDesignEnggArray.includes(_elecEngId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.MechanicalDesignEngineer)){
        if(!this.mechDesignEnggArray.includes(_mechEnggId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.C30Engineer)){
        if(!this.c30EnggArray.includes(_c30EngId)) return false;
      }
    }
    return true;
  }

  exportasexcel(){
    let element = document.getElementById('excel-table');
    //To remove the titles for the export of the excel
    let arr = document.getElementsByClassName('table');
        
    for (var i = 0; i < arr.length; i++) {

      var t_temp = arr[i].children[0].children[2] //thead reference for appending it later

      // Remove the filters values from the excel export
      var t = arr[i].children[0].children[2] //thead reference
      t.remove();
      
      // Remove the title(tooltips) from the excel export
      var b = arr[i].children[1] //tbody reference
      var d = b.getElementsByTagName('div');
      var len = d.length
      // var len = 17;
      for (var i = 0; i < len; i++) {
        if (d.item(i).hasAttribute("title")) {
          d.item(i).removeAttribute("title");
        }
      }
    }
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
        raw: false
      });//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'gantt.xlsx');

      // Append the filters after export
      let arr1 = document.getElementsByClassName('table');
      for (var i = 0; i < arr1.length; i++) {
  
        // Append the filters values from the excel export
      var t1 = arr1[i].children[0]; //thead parent reference      
      t1.appendChild(t_temp); 

      }
      this.reloadData();
  }

  minrFunc(){
    this.filteredCustPOVal = this.filteredCustPOVal_temp;
    this.filteredAmmendPOVal = this.filteredAmmendPOVal_temp;
    this.filteredPOValue = this.filteredPOValue_temp;
    this.unitName = "minr";
    
  }
  tinrFunc(){
    this.filteredCustPOVal = this.filteredCustPOVal_temp/1000;
    this.filteredAmmendPOVal = this.filteredAmmendPOVal_temp/1000;
    this.filteredPOValue = this.filteredPOValue_temp/1000;
    this.unitName = "tinr";
    
  }
  musdFunc(){
    this.filteredCustPOVal = this.filteredCustPOVal_temp*0.0133;
    this.filteredAmmendPOVal = this.filteredAmmendPOVal_temp*0.0133;
    this.filteredPOValue = this.filteredPOValue_temp*0.0133;
    this.unitName = "musd";
    
  }
  getSAPSyncStatus() {
    this._dataService.getSAPSyncStatus().subscribe((res: any) => {
    });
  }
  closeSAPModal() {
    this.showSAPModal = false;
  }

  onSAPSoInput(event: any) {
    this.selectedSAPSo = event.target.value.replace(/[^0-9]/g, '');
  }
    createSAPRequest() {
      this.isSAPLoading = true;
      this.saleOrderFromSAP = [];
      try {
        let msg = {
          "SO_NUMBER": this.selectedSAPSo
        };

        console.log('SAP Request Message:', msg);

        this._dataService.getDataFromSAP(msg).subscribe((res: any) => {
          this.isSAPLoading = false;
          // console.log('SAP Response:', res);
          if (res && res.saleOrdNos && res.saleOrdNos.length > 0) {
            for (let i = 0; i < res.saleOrdNos.length; i++) {
              this.saleOrderFromSAP.push({
                saleOrdNo: res.saleOrdNos[i].saleOrdNo,
                status: res.saleOrdNos[i].status,
                details: res.saleOrdNos[i].details || ''
              });
            }
            this.salesOrderFetchedFromSAP = {
              date: this.selectedSAPSo,
              items: this.saleOrderFromSAP
            };
            // console.log('Fetched:', this.salesOrderFetchedFromSAP);
            this.messageDetailsFromSAP = res.message || 'SAP data fetched successfully.';
            this.showSAPModal = true;
          } else {
            this.salesOrderFetchedFromSAP = { date: this.selectedSAPSo, items: [] };
            this.messageDetailsFromSAP = res.message || 'No SAP data available.';
            this.showSAPModal = true;
            console.error('No SAP data found:', res);
          }
          this.reloadData();
        }, err => {
          this.isSAPLoading = false;
          this.salesOrderFetchedFromSAP = { date: this.selectedSAPSo, items: [] };
          console.error('SAP fetch error:', err);
          this.reloadData();
        });
      } catch (e) {
        this.isSAPLoading = false;
        this.salesOrderFetchedFromSAP = { date: this.selectedSAPSo, items: [] };
        console.error(e);
      }
    }

}

export enum filterOption{
  All = 0,
  Delay = -1,
  Early = 1,
  NotStarted = 2,
  Pending = 6, 
  Partial = 3,
  Waiting = 4,
  Complete = 5,
  Relay_pending = 8
}